/*
HeaderMenu.js
头部栏
 */

import React from 'react';
import {Button, Row, Col, Space} from "antd";
import {MenuUnfoldOutlined} from "@ant-design/icons";

import MobileDropdownMenu from "./MobileDropdownMenu/MobileDropdownMenu";


const HeaderMenu = ({isMobile, showDrawer}) => {
    return (
        <Row justify="space-between" align="middle" style={{width: '100%'}}>
            <Col style={{marginLeft: '20px'}}>
                {isMobile && (
                    <Button type="text" icon={<MenuUnfoldOutlined />}
                            onClick={showDrawer}
                            size="large"/>
                )}
            </Col>
            <Col style={{marginRight: '20px'}}>
                <Space>
                    {isMobile && (
                        <MobileDropdownMenu />
                    )}
                    <Button type="primary" style={{background: '#8C1C21', display: 'none'}} size="large">
                        登录
                    </Button>
                </Space>
            </Col>
        </Row>
    );
};

export default HeaderMenu;